import { render, staticRenderFns } from "./recordingButton.vue?vue&type=template&id=b1911ec8&scoped=true"
import script from "./recordingButton.vue?vue&type=script&lang=js"
export * from "./recordingButton.vue?vue&type=script&lang=js"
import style0 from "./recordingButton.vue?vue&type=style&index=0&id=b1911ec8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1911ec8",
  null
  
)

export default component.exports